import Papa from 'papaparse';
import type { ProductInput } from '../../services/socialPosting';
import { REQUIRED_CSV_FIELDS } from './csvTemplate';

export interface CSVParseResult {
  products: ProductInput[];
  errors: string[];
  detectedFields: string[];
}

export function parseCSV(file: File): Promise<CSVParseResult> {
  return new Promise((resolve) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const errors: string[] = [];

        // Check for parse errors
        if (results.errors.length > 0) {
          for (const err of results.errors.slice(0, 5)) {
            errors.push(`Row ${err.row ?? '?'}: ${err.message}`);
          }
        }

        const headers = results.meta.fields || [];

        // Validate required fields
        const missingFields = REQUIRED_CSV_FIELDS.filter((f) => !headers.includes(f));
        if (missingFields.length > 0) {
          errors.push(`Missing required columns: ${missingFields.join(', ')}`);
          resolve({ products: [], errors, detectedFields: headers });
          return;
        }

        const rows = results.data as Record<string, string>[];
        const products: ProductInput[] = [];

        for (let i = 0; i < rows.length; i++) {
          const row = rows[i];
          const id = row.id?.trim();
          const title = row.title?.trim();

          if (!id) {
            errors.push(`Row ${i + 2}: missing id`);
            continue;
          }
          if (!title) {
            errors.push(`Row ${i + 2}: missing title`);
            continue;
          }

          // All fields go into raw_data (including custom ones)
          const rawData: Record<string, unknown> = {};
          for (const [key, value] of Object.entries(row)) {
            if (value !== undefined && value !== '') {
              rawData[key] = value;
            }
          }

          products.push({
            feed_product_id: id,
            feed_id: 'csv-import',
            sort_order: i,
            raw_data: rawData,
          });
        }

        resolve({ products, errors, detectedFields: headers });
      },
    });
  });
}
